import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ButtonLevel, ButtonStyle, ButtonType } from '@challenger6/vm-pattern-library/button';

@Component({
  selector: 'vm-carousel-navigation',
  templateUrl: './carousel-navigation.component.html',
  styleUrls: ['./carousel-navigation.component.scss'],
})
export class CarouselNavigationComponent {
  readonly buttonType = ButtonType;
  @Input() nextButtonLevel = ButtonLevel.TERTIARY;
  @Input() prevButtonLevel = ButtonLevel.TERTIARY;
  @Input() prevButtonStyle = [ButtonStyle.OUTLINE];
  @Input() nextCopy = 'Next';
  @Input() prevCopy = 'Previous';

  @Output() nextButtonClick = new EventEmitter();
  @Output() prevButtonClick = new EventEmitter();

  onNext(event) {
    this.stopEvent(event);
    this.nextButtonClick.emit();
  }

  onPrev(event) {
    this.stopEvent(event);
    this.prevButtonClick.emit();
  }

  private stopEvent(event) {
    if (event) {
      event.stopPropagation();
    }
  }
}
